//#region src/protocol/athena/uuid.ts
/** Base from which 16-bit and 32-bit Bluetooth UUIDs expand. */
const BLUETOOTH_BASE = "0000-1000-8000-00805f9b34fb";
/**
* Normalises a characteristic UUID to the canonical dashed 128-bit form.
*
* Platforms disagree on spelling — Web Bluetooth uses the dashed form, noble
* strips the dashes, and 16-bit UUIDs appear both expanded and short — so any
* comparison has to normalise first or it will silently miss.
*/
function toCanonicalCharacteristicUuid(uuid) {
	const hex = uuid.replaceAll("-", "").toLowerCase();
	if (hex.length === 4) return `0000${hex}-${BLUETOOTH_BASE}`;
	if (hex.length === 8) return `${hex}-${BLUETOOTH_BASE}`;
	if (hex.length !== 32) return hex;
	return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
/** Whether two UUIDs denote the same characteristic, whatever their spelling. */
function sameCharacteristicUuid(a, b) {
	return toCanonicalCharacteristicUuid(a) === toCanonicalCharacteristicUuid(b);
}
//#endregion
export { toCanonicalCharacteristicUuid as n, sameCharacteristicUuid as t };

//# sourceMappingURL=uuid-D9bCf1aR.js.map